import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";
import StarsIcon from "@mui/icons-material/Stars";
import { Button, Typography, styled } from "@mui/material";
import clsx from "clsx";
import Skeleton from "react-loading-skeleton";
import RawHTML from "../../../components/raw-html/raw-html";
import { IRootState } from "../../../redux/root.reducer";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { canAccessLegacyLinks } from "../../../service/user-permission";
import { openLegacyUrl } from "../../../shared/component/open-legacy-url";
import { IWithClassName, IWithThemeProps } from "../../../theme/default.theme";
import { trackListAction } from "../redux/list-details/list-details.actions";

const ListDescription = ({ className }: IWithClassName) => {
    const dispatch = useAppDispatch();
    const { isLoading, details } = useAppSelector(
        ({ listPage }) => listPage.listDetails,
    );
    const role = useAppSelector(({ auth }: IRootState) => auth.user?.role);
    const hasLegacylinkAccess = canAccessLegacyLinks(role);

    const handleTrackClick = () => {
        if (!isLoading) {
            dispatch(trackListAction(!details?.isTracked));
        }
    };
    const TrackIcon =
        !isLoading && details?.isTracked ? StarsIcon : StarBorderRoundedIcon;

    return (
        <div className={className}>
            <Typography
                variant="h6"
                className={clsx("list-heading", { loading: isLoading })}
            >
                Complete List of {details?.name} Locations
                <TrackIcon
                    className={clsx("list-track", { clickable: !isLoading })}
                    onClick={handleTrackClick}
                />
                {hasLegacylinkAccess && details?.listId && (
                    <div className="button-container">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() =>
                                openLegacyUrl(`/lists/${details?.listId}/edit?`)
                            }
                        >
                            Edit
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() =>
                                openLegacyUrl(`/lists/${details?.listId}`)
                            }
                        >
                            Legacy View
                        </Button>
                    </div>
                )}
            </Typography>
            {isLoading ? (
                <Skeleton count={3} />
            ) : (
                details?.description && (
                    <RawHTML
                        content={details?.description}
                        className="list-description"
                    />
                )
            )}
        </div>
    );
};

export default styled(ListDescription)(({ theme }: IWithThemeProps) => ({
    ".list-description": {
        color: theme?.palette.announcement.primaryColor,
        lineHeight: 1.8,
        fontSize: "18px",
        marginBottom: theme?.spacing(3),
    },
    ".list-heading": {
        color: theme?.palette.text.primary,
        fontSize: "20px",
        marginBottom: theme?.spacing(2),
        fontWeight: 400,
        textTransform: "uppercase",
        "&.loading": {
            filter: "blur(4px)",
        },
        ".clickable": {
            cursor: "pointer",
        },
    },
    ".list-track": {
        verticalAlign: "sub",
        marginLeft: theme?.spacing(2.5),
        color: theme?.palette.action.active,
        "&:not(.clickable)": {
            filter: "blur(4px)",
        },
    },
    ".button-container": {
        display: "inline-flex",
        gap: theme?.spacing(2),
        marginLeft: theme?.spacing(2),
    },
}));
